import proj4 from "proj4";

const PROFILE_KEY = "hydrotools:projection-profile:v1";
const CUSTOM_CRS_KEY = "hydrotools:projection-custom:v1";

const BUILTIN_CRS = [
  { code: "EPSG:4326", name: "WGS 84 (Lat/Lon)", proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs" },
  { code: "EPSG:3857", name: "Web Mercator", proj4: "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs" },
  { code: "EPSG:2273", name: "NAD83 / South Carolina (US-ft)", proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:32610", name: "WGS 84 / UTM zone 10N", proj4: "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32611", name: "WGS 84 / UTM zone 11N", proj4: "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:26910", name: "NAD83 / UTM zone 10N", proj4: "+proj=utm +zone=10 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26911", name: "NAD83 / UTM zone 11N", proj4: "+proj=utm +zone=11 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26941", name: "NAD83 / California zone 1 (m)", proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26942", name: "NAD83 / California zone 2 (m)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26943", name: "NAD83 / California zone 3 (m)", proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26944", name: "NAD83 / California zone 4 (m)", proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26945", name: "NAD83 / California zone 5 (m)", proj4: "+proj=lcc +lat_0=34 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26946", name: "NAD83 / California zone 6 (m)", proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:2225", name: "NAD83 / California zone 1 (ftUS)", proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2226", name: "NAD83 / California zone 2 (ftUS)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2227", name: "NAD83 / California zone 3 (ftUS)", proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2228", name: "NAD83 / California zone 4 (ftUS)", proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2229", name: "NAD83 / California zone 5 (ftUS)", proj4: "+proj=lcc +lat_0=34 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2230", name: "NAD83 / California zone 6 (ftUS)", proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
];

const DEFAULT_PROFILE = {
  name: "Default Hydro Profile",
  horizontalCRS: "EPSG:4326",
  verticalDatum: "MSL",
  geoidModel: "None",
  linearUnits: "meters",
  angularUnits: "degrees",
};

function normalizeCode(code) {
  return String(code || "").trim().toUpperCase();
}

function isFiniteCoord(v) {
  return Number.isFinite(Number(v));
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function createProjectionService({ events }) {
  const customCRS = new Map();
  let profile = { ...DEFAULT_PROFILE };

  function persistProfile() {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  }

  function persistCustomCRS() {
    const arr = [...customCRS.values()];
    localStorage.setItem(CUSTOM_CRS_KEY, JSON.stringify(arr));
  }

  function loadProfile() {
    try {
      const raw = localStorage.getItem(PROFILE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return;
      profile = { ...DEFAULT_PROFILE, ...parsed };
    } catch (err) {
      console.error("[Projections] profile load failed", err);
    }
  }

  function loadCustomCRS() {
    try {
      const raw = localStorage.getItem(CUSTOM_CRS_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return;
      for (const def of parsed) {
        if (!def || typeof def !== "object") continue;
        const code = normalizeCode(def.code);
        const proj = String(def.proj4 || "").trim();
        const name = String(def.name || code).trim();
        if (!code || !proj) continue;
        proj4.defs(code, proj);
        customCRS.set(code, { code, name, proj4: proj });
      }
    } catch (err) {
      console.error("[Projections] custom CRS load failed", err);
    }
  }

  function seedBuiltins() {
    for (const def of BUILTIN_CRS) {
      proj4.defs(def.code, def.proj4);
    }
  }

  function listCRS() {
    const all = [...BUILTIN_CRS, ...customCRS.values()];
    return all
      .slice()
      .sort((a, b) => a.code.localeCompare(b.code))
      .map((x) => ({ ...x }));
  }

  function getCRS(code) {
    const key = normalizeCode(code);
    return listCRS().find((x) => normalizeCode(x.code) === key) || null;
  }

  function registerCRS({ code, name, proj4: proj }) {
    const normalized = normalizeCode(code);
    const projStr = String(proj || "").trim();
    if (!normalized || !projStr) throw new Error("CRS code and proj4 are required");
    proj4.defs(normalized, projStr);
    customCRS.set(normalized, { code: normalized, name: String(name || normalized).trim(), proj4: projStr });
    persistCustomCRS();
    events.emit("projection:catalog:changed", { crs: listCRS() });
    return normalized;
  }

  function removeCustomCRS(code) {
    const normalized = normalizeCode(code);
    const removed = customCRS.delete(normalized);
    if (!removed) return false;
    persistCustomCRS();
    events.emit("projection:catalog:changed", { crs: listCRS() });
    return true;
  }

  function getProjectProfile() {
    return { ...profile };
  }

  function setProjectProfile(next) {
    profile = { ...profile, ...(next || {}) };
    persistProfile();
    events.emit("projection:profile:changed", { profile: getProjectProfile() });
    return getProjectProfile();
  }

  function resetProjectProfile() {
    profile = { ...DEFAULT_PROFILE };
    persistProfile();
    events.emit("projection:profile:changed", { profile: getProjectProfile() });
    return getProjectProfile();
  }

  function resolveDef(input) {
    if (typeof input === "string") {
      const trimmed = input.trim();
      if (!trimmed) throw new Error("Missing CRS");
      if (trimmed.includes("+proj=")) return trimmed;
      return normalizeCode(trimmed);
    }
    if (input && typeof input === "object") {
      if (input.proj4) return String(input.proj4).trim();
      if (input.code) return normalizeCode(input.code);
    }
    throw new Error("Invalid CRS");
  }

  function transformCoord(coord, fromCRS, toCRS) {
    if (!Array.isArray(coord) || coord.length < 2) throw new Error("Coordinate must be [x,y]");
    if (!isFiniteCoord(coord[0]) || !isFiniteCoord(coord[1])) throw new Error("Coordinate must be numeric");
    const from = resolveDef(fromCRS);
    const to = resolveDef(toCRS);
    if (from === to) return coord.slice();
    const [x, y] = proj4(from, to, [Number(coord[0]), Number(coord[1])]);
    if (coord.length > 2) return [x, y, coord[2]];
    return [x, y];
  }

  function transformGeometry(geometry, fromCRS, toCRS) {
    if (!geometry || typeof geometry !== "object") return geometry;
    const g = clone(geometry);
    const xformPos = (pos) => transformCoord(pos, fromCRS, toCRS);

    function walkCoords(node) {
      if (!Array.isArray(node)) return node;
      if (node.length >= 2 && isFiniteCoord(node[0]) && isFiniteCoord(node[1])) return xformPos(node);
      return node.map((child) => walkCoords(child));
    }

    if (g.type === "GeometryCollection" && Array.isArray(g.geometries)) {
      g.geometries = g.geometries.map((child) => transformGeometry(child, fromCRS, toCRS));
      return g;
    }

    g.coordinates = walkCoords(g.coordinates);
    return g;
  }

  function transformFeatureCollection(fc, fromCRS, toCRS) {
    if (!fc || fc.type !== "FeatureCollection" || !Array.isArray(fc.features)) {
      throw new Error("Expected GeoJSON FeatureCollection");
    }
    const out = clone(fc);
    out.features = out.features.map((f) => ({
      ...f,
      geometry: transformGeometry(f.geometry, fromCRS, toCRS),
    }));
    return out;
  }

  seedBuiltins();
  loadCustomCRS();
  loadProfile();

  return {
    listCRS,
    getCRS,
    registerCRS,
    removeCustomCRS,
    getProjectProfile,
    setProjectProfile,
    resetProjectProfile,
    transformCoord,
    transformGeometry,
    transformFeatureCollection,
  };
}
